"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* Configuration for the links that are automatically picked up by the built-in cross domain linker */
const crossDomainExtendedConfig = (domain) => {
    return {
        userId: true,
        sessionId: true,
        sourceId: true,
        sourcePlatform: true,
        reason: (evt) => domain, // can be anything - using the domain for this
    };
};
exports.default = crossDomainExtendedConfig;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3Jvc3NEb21haW5FeHRlbmRlZENvbmZpZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy91dGlscy9jcm9zc0RvbWFpblRyYWNraW5nL2Nyb3NzRG9tYWluRXh0ZW5kZWRDb25maWcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQSxzR0FBc0c7QUFDdEcsTUFBTSx5QkFBeUIsR0FBRyxDQUFDLE1BQWMsRUFBdUMsRUFBRTtJQUN0RixPQUFPO1FBQ0gsTUFBTSxFQUFFLElBQUk7UUFDWixTQUFTLEVBQUUsSUFBSTtRQUNmLFFBQVEsRUFBRSxJQUFJO1FBQ2QsY0FBYyxFQUFFLElBQUk7UUFDcEIsTUFBTSxFQUFFLENBQUMsR0FBVSxFQUFVLEVBQUUsQ0FBQyxNQUFNLEVBQUUsOENBQThDO0tBQ3pGLENBQUM7QUFDTixDQUFDLENBQUM7QUFFRixrQkFBZSx5QkFBeUIsQ0FBQyJ9


// WEBPACK FOOTER //
// ../../../../src/utils/crossDomainTracking/crossDomainExtendedConfig.ts